import { render, staticRenderFns } from "./Church.vue?vue&type=template&id=fd6bcd34&"
import script from "./Church.vue?vue&type=script&lang=js&"
export * from "./Church.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports